import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { keepPreviousData } from '@tanstack/vue-query';

import type { IAffiliateProgramPromoCodeListItem } from '../types';
import {
  AFFILIATE_PROGRAM_PROMO_CODES_LIST_API_URL,
  AFFILIATE_PROGRAM_PROMO_CODES_LIST_QUERY_KEY,
  AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS,
} from '../constants';

export default function useAffiliateProgramPromoCodesListQuery(
  tableState: Ref<ITableState>,
): IContextQueryResult<ITableDataResponse<IAffiliateProgramPromoCodeListItem>, Error> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<IAffiliateProgramPromoCodeListItem>>({
    queryKey: [AFFILIATE_PROGRAM_PROMO_CODES_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<IAffiliateProgramPromoCodeListItem>>(
      AFFILIATE_PROGRAM_PROMO_CODES_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: AFFILIATE_PROGRAM_PROMO_CODES_PERMISSIONS.SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
